import gql from 'graphql-tag'
import { resourceUnavailabilityFragment, resourceUnavailabilityTypeFragment } from '@/graphql/resourceUnavailability/resourceUnavailabilityFragments'

export const RESOURCEUNAVAILABILITYTYPES = gql`
    query resourceUnavailabilityTypes(
        $trashed: Trashed
    ){
        resourceUnavailabilityTypes(
            trashed: $trashed
        ){
            ...resourceUnavailabilityTypeFragment
        }
    }
    ${resourceUnavailabilityTypeFragment}
`


export const RESOURCEUNAVAILABILITIES = gql`
    query resourceUnavailabilities(
        $ids: [ID]
        $resourceID: ID
        $page: Int
        $first: Int
    ){
        resourceUnavailabilities(
            ids: $ids
            page: $page
            first: $first
            resourceID: $resourceID
        ){
            data{
                ...resourceUnavailabilityFragment
                type{
                    ...resourceUnavailabilityTypeFragment
                }
            }
        }
    }
    ${resourceUnavailabilityFragment}
    ${resourceUnavailabilityTypeFragment}
`

export const USERRESOURCEUNAVAILABILITIES = gql`
    query userResourceUnavailabilitys(
        $resourceID: ID
        $dateRange: activeDuringInputSingleDate
    ){
        userResourceUnavailabilitys(
            resourceID: $resourceID
            dateRange: $dateRange
        ){
            data{
                ...resourceUnavailabilityFragment
                type{
                    ...resourceUnavailabilityTypeFragment
                }
            }
        }
    }
    ${resourceUnavailabilityFragment}
    ${resourceUnavailabilityTypeFragment}
`